import {
  SalesDashboardRoute,
  SalesDashboardPathName,
} from '@/modules/ta/salesdashboard/salesdashboard.constants';
import { SalesDashboardRouteConfig } from '@/modules/ta/salesdashboard/SalesDashboardRouteConfig';

export const router = SalesDashboardRouteConfig.factory([
  {
    path: `/${SalesDashboardRoute.SALES_DASHBOARD}`,
    name: SalesDashboardPathName.SALES_DASHBOARD,
    component: () =>
      import(/* webpackChunkName: "sales-dashboard-page" */ './pages/SalesDashboardPage.vue'),
  },
]);
